var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "custom-dialog" }, [
        _c("div", { staticClass: "model" }),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.conf.title))]),
          _c("div", { staticClass: "context" }, [
            _vm._v(_vm._s(_vm.conf.text)),
          ]),
          _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "button confirm",
                on: {
                  click: function ($event) {
                    return _vm.confirm()
                  },
                },
              },
              [
                _vm.conf.type === "google"
                  ? _c("Google", { on: { login: _vm.confirm } })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "txt",
                    class: { google: _vm.conf.type === "google" },
                  },
                  [_vm._v(_vm._s(_vm.conf.confirmTxt))]
                ),
              ],
              1
            ),
            _vm.conf.cancelTxt
              ? _c(
                  "div",
                  {
                    staticClass: "button cancel",
                    on: {
                      click: function ($event) {
                        _vm.visible = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.conf.cancelTxt))]
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }